import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import useErrors from '../../hooks/useErrors';
import { useForgotPassword } from '../../hooks/mutations/useUserMutations';
import isEmailValid from '../../utils/isEmailValid';
import * as styles from './styles';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const { mutate: forgotPassword, isPending } = useForgotPassword();
  const { setError, removeError, getErrorMessageByFieldName, errors } = useErrors();

  function handleEmail(e) {
    setEmail(e.target.value);
    removeError('email');
  }

  function onSubmit() {
    if (!email) {
      setError({ field: 'email', message: 'O email está vazio' });
      return;
    }

    if (!isEmailValid(email)) {
      setError({ field: 'email', message: 'O email não é válido' });
      return;
    }

    forgotPassword(email, {
      onSuccess: () => {
        setSent(true);
      },
      onError: () => {
        toast.error('Erro ao enviar o email. Tente novamente.');
      },
    });
  }

  const isFormValid = Boolean(email) && errors.length === 0;

  if (sent) {
    return (
      <FormContainer>
        <Center className="center">
          <styles.SuccessContainer>
            <styles.SuccessIcon>✉️</styles.SuccessIcon>
            <Title
              title="Email enviado!"
              subtitle="Verifique sua caixa de entrada (e o spam) para o link de redefinição de senha."
            />
            <styles.BackLink>
              <Link to="/modellogin">Voltar para o login</Link>
            </styles.BackLink>
          </styles.SuccessContainer>
        </Center>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <Center className="center">
        <Title
          title="Esqueceu sua senha?"
          subtitle="Informe seu email e enviaremos um link para redefinir sua senha."
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Enviar link"
          isLoading={isPending}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('email')}>
            <label>Email*</label>
            <input
              type="email"
              placeholder="Digite seu email cadastrado"
              value={email}
              onChange={handleEmail}
            />
          </GroupInput>
        </FormAuth>

        <styles.BackLink>
          <Link to="/modellogin">Voltar para o login</Link>
        </styles.BackLink>
      </Center>
    </FormContainer>
  );
}
